export const AddressItemTransformer = (address) => {
  if (!address) return null;

  const locationInfo =
    address.metadata.length === 0
      ? null
      : address.metadata.find(({ key }) => key === "location")?.value;

  return {
    id: address?.id,
    country: address?.country?.code || "",
    region: address?.countryArea || "",
    postal_code: address?.postalCode || "",
    city: address.city.toLowerCase(),
    address: address?.streetAddress1 || "",
    details: address?.streetAddress2 || "",
    location: locationInfo
      ? {
          lng: locationInfo?.split(", ")[0],
          lat: locationInfo?.split(", ")[1],
        }
      : null,
    company_name: address?.companyName || "",
    firstName: address?.firstName || "",
    lastName: address?.lastName || "",
    phone: address?.phone || "",
  };
};
